<template>
  <v-app id="inspire" class="app dashboard">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style>
.v-application {
    background-color: var(--v-background-base) !important;
}
</style>
